/**
 * Egenhostade videobilder (webp) för de klipp som visas på startsidan.
 * Tar bort tredjepartsanrop till i.ytimg.com i den kritiska renderingen.
 * Filerna genereras från YouTube-stillbilder och ligger i public/thumbs/.
 */
const LOCAL_THUMBS = new Set([
  "9iiyNS4yNzA",
  "yvojXrb41Aw",
  "HwWGVOl6dtg",
  "KkE8BqgQ14M",
  "UU_Ys1M431I",
  "WONrMkeJuik",
  "O2zdqLfmM5E",
]);

/** Lokal webp när den finns, annars YouTubes CDN. */
export function videoThumb(id: string): string {
  return LOCAL_THUMBS.has(id)
    ? `/thumbs/${id}.webp`
    : `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
}

export function hasLocalThumb(id: string): boolean {
  return LOCAL_THUMBS.has(id);
}
